import { styled } from '@mui/material';

export const H1Styled = styled('h2')(({ theme }) => ({
  paddingTop: theme.spacings.unit(10),
  color: theme.colors.primaryText,
  fontSize: theme.fonts.utility.size(12),
  fontWeight: 600,
  margin: 0,
}));
